<div class="app-modal app-modal-simple">
  <div class="app-modal-header">
    <dx-button class="app-modal-new-window-icon" (click)="onOpenHelpInNewTab()">
      <i class="icon-logout"></i>
    </dx-button>
    <dx-button class="button-close" icon="close" (click)="onCloseClick()"></dx-button>
  </div>
  @if(loadedUrl){ <div class="app-modal-content p0">
    <iframe [src]="loadedUrl" id="helpIframe" class="iframe"> </iframe>
  </div>}
</div>